import { render, staticRenderFns } from "./FlightInfo.vue?vue&type=template&id=6b2df2fd&scoped=true"
import script from "./FlightInfo.vue?vue&type=script&lang=js"
export * from "./FlightInfo.vue?vue&type=script&lang=js"
import style0 from "./FlightInfo.vue?vue&type=style&index=0&id=6b2df2fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2df2fd",
  null
  
)

export default component.exports